"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _excluded = ["id", "onSelect", "autoComplete", "onChange", "onBlur", "value", "label", "variant", "error", "helperText", "getOptionLabel", "loading", "options", "dataQa", "disabled", "freeSolo"];

var Autocomplete = function Autocomplete(_ref) {
  var id = _ref.id,
      onSelect = _ref.onSelect,
      autoComplete = _ref.autoComplete,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      value = _ref.value,
      label = _ref.label,
      variant = _ref.variant,
      error = _ref.error,
      helperText = _ref.helperText,
      getOptionLabel = _ref.getOptionLabel,
      loading = _ref.loading,
      options = _ref.options,
      dataQa = _ref.dataQa,
      disabled = _ref.disabled,
      freeSolo = _ref.freeSolo,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], (0, _extends2["default"])({}, rest, {
    freeSolo: freeSolo,
    autoComplete: autoComplete,
    onChange: function onChange(event, value) {
      return value && onSelect(value);
    },
    onInputChange: onChange,
    getOptionLabel: getOptionLabel,
    options: options || [],
    loading: loading,
    inputValue: value,
    disabled: disabled,
    renderInput: function renderInput(params) {
      return (
        /*#__PURE__*/
        // TODO: Use TextField from olimpic lib. Can't forward refs.
        _react["default"].createElement(_core.TextField, (0, _extends2["default"])({}, params, {
          id: id,
          type: "text",
          label: label,
          variant: variant,
          error: error,
          helperText: helperText || /*#__PURE__*/_react["default"].createElement("span", null),
          onBlur: onBlur,
          InputProps: (0, _extends2["default"])({}, params.InputProps, {
            inputProps: (0, _extends2["default"])({
              'aria-describedby': id && "".concat(id, "-helper-text"),
              'data-qa': dataQa
            }, params.inputProps),
            endAdornment: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
              condition: loading === true
            }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
              color: "inherit",
              size: 20
            })), params.InputProps.endAdornment)
          })
        }))
      );
    }
  }));
};

Autocomplete.propTypes = {
  id: _propTypes["default"].string,
  onSelect: _propTypes["default"].func.isRequired,
  autoComplete: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  onBlur: _propTypes["default"].func,
  value: _propTypes["default"].string,
  label: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['standard', 'outlined', 'filled']),
  error: _propTypes["default"].bool,
  helperText: _propTypes["default"].string,
  getOptionLabel: _propTypes["default"].func.isRequired,
  loading: _propTypes["default"].bool,
  options: _propTypes["default"].array.isRequired,
  dataQa: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  freeSolo: _propTypes["default"].bool
};
Autocomplete.defaultProps = {
  autoComplete: false,
  value: '',
  label: '',
  variant: 'outlined',
  options: [],
  freeSolo: true
};
var _default = Autocomplete;
exports["default"] = _default;